import axios from "axios"
import useSWR from "swr"

const fetcher = async (url, params) => {
    return await axios.get(url, { params }).then((res) => res.data.data)
}

// Ringkasan penjualan harian dengan logika IDENTIK laporan EOD (paid_date + status final).
// Dipakai dashboard untuk KPI "Penjualan Hari Ini" & grafik tren.
const useDailySalesSummaryRepositories = (params) => {
    const shouldFetch = params?.enabled !== false
    const requestParams = { ...params }
    delete requestParams.enabled

    const hasRequiredParams = Boolean(requestParams.date_from) && Boolean(requestParams.date_to)

    const { data, error, mutate, isValidating } = useSWR(
        shouldFetch && hasRequiredParams
            ? [`${process.env.REACT_APP_INVENTORY_API_URL}/orders/daily-sales-summary`, requestParams]
            : null,
        fetcher
    )

    return {
        data,
        isLoading: shouldFetch && hasRequiredParams && !error && !data,
        error,
        isValidating,
        mutate,
    }
}

export default useDailySalesSummaryRepositories
